import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { VisitSchedulingQuestionnaireItem } from './questionnaire'

export const VISIT_SCHEDULING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE]:
    QuestionnaireAnswerType.GROUP,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_WAKEUP_TIME]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_BEDTIME]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES]:
    QuestionnaireAnswerType.GROUP,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_DAY]:
    QuestionnaireAnswerType.STRING,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_SCHOOL_TIMES_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS]:
    QuestionnaireAnswerType.GROUP,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_NAME]:
    QuestionnaireAnswerType.STRING,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_PATIENT_SCHEDULE_OTHER_APPOINTMENTS_REPEATS_ON_DAY]:
    QuestionnaireAnswerType.STRING,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VALID]:
    QuestionnaireAnswerType.BOOLEAN,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS]:
    QuestionnaireAnswerType.GROUP,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD]:
    QuestionnaireAnswerType.GROUP,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_START]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_END]:
    QuestionnaireAnswerType.TIME,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_CAREGIVER]:
    QuestionnaireAnswerType.STRING,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_WEEKDAY]:
    QuestionnaireAnswerType.STRING,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_SERVICE_TYPE]:
    QuestionnaireAnswerType.REFERENCE,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_CHANGE_REASON]:
    QuestionnaireAnswerType.STRING,
  [VisitSchedulingQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_ADDITIONAL_NOTES]:
    QuestionnaireAnswerType.STRING
}
